import useSWR from 'swr';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import {Messages} from './types';

export function fetchMessagesRequest(filter?: boolean) {
  return useSWR<Messages, unknown, [string]>(
    [
      `/api/v1/notification_logs/${
        filter !== undefined ? `?seen=${filter}` : ''
      }`,
    ],
    ([url]) =>
      letrusAPI(url, {
        params: {
          channel: 'recommendation',
          created__year: new Date().getFullYear(),
        },
      }).then((response) => response.data),
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    },
  );
}
